/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { GET_ASSET_DETAIL } from "../pages/MintedAssetDetail/graphql/minted-asset-detail.query";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import {LIST_ASSET } from "../pages/MintedAssetDetail/graphql/list-asset.mutation"
import {DETAIL_DATA} from "./config/minted-asset.detail"
import { GET_CATEGORIES} from "../pages/MintedAssetDetail/graphql/get-categories.query";
import {LIST_ASSET_FIELDS,LIST_ASSET_FORM_DATA } from "./config/get-categories-form";
import { humanize} from "uno-js"

const MODULE_NAME = "MintedAssetDetailService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class MintedAssetDetailService {
    private static instance: MintedAssetDetailService;
    private vapp: VApplication;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
    }
    public static getInstance(props: any = {}): MintedAssetDetailService {
        if (!MintedAssetDetailService.instance) {
            MintedAssetDetailService.instance = new MintedAssetDetailService(props);
        }
        return MintedAssetDetailService.instance;
    }

    // async getMintedAssetDetail(assetId: string, assetGroup: string) {
    //     const graphqlModule = getGraphQLModule();
    //     const client = graphqlModule.getClient("graphql-gateway");
    //     try {
    //         if (client) {
    //             const res = await client.query({
    //                 query: GET_ASSET_DETAIL,
    //                 variables: {
    //                     getAssetDetailsAssetId: assetId,
    //                     getAssetDetailsAssetGroup: assetGroup,
    //                 },
    //                 fetchPolicy:'network-only'
    //             });
    //             log.success(MODULE_NAME, "getMintedAssetDetail: ", res);
    //             if (res?.data?.getAssetDetails?.tabsItems) {
    //                 try {
    //                     // Parse a JSON
    //                     res.data.getAssetDetails.tabsItems = JSON.parse(res?.data?.getAssetDetails?.tabsItems);
    //                 } catch (e) {
    //                     // You can read e for more info
    //                 }
    //             }
    //             return res?.data?.getAssetDetails;
    //         }
    //     } catch (err) {
    //     }
    // }

    // async getMintedAssetDetail(assetId: string) {
    //     const _found = _.find(DETAIL_DATA, {
    //         idx: assetId,
    //     });
    //     return _found;
    // }

    async getMintedAssetDetail(assetId: string) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: GET_ASSET_DETAIL,
                    variables: {
                        tokenId:assetId,
                        // storeId:"61739cbd2fbe0a187c984fb6"
                    },
                });
                if(res){
                    let _data = res?.data?.getAsset
                    let _found ={
                        idx: _data?.idx,
                        title: _data?.title,
                        subtitle: _data?.subtitle,
                        serialNo: _data?.serialNo,
                        tag: 'GOLD',
                        category: 'gold',
                        price: _data?.price,
                        meta: _data?.attrs?.map((item:any)=>{
                            return({
                                key:item?.name,
                                value: item?.val,
                                disp_type:item?.disp_type
                            })
                        }),
                        buttons: [
                            // {
                            //     key: "buyNowFiat",
                            //     title: "Buy in USD"
                            // },
                            // {
                            //     key: "buyNowCrypto",
                            //     title: "Buy in ETH"
                            // }
                            {
                                key:"list",
                                title:"List"
                            }
                        ],
                        images: _data?.media?.map((item:any)=>{
                            return({
                                original:item?.src,
                                thumbnail:item?.src,
                                thumbnailHeight: "70",
                                thumbnailClass:"image-thumb"
                            })
                        }),
                        // timeline: _data?.timeline?.map((item:any)=>{
                        //     return({
                        //         title: item?.event,
                        //         description:[
                        //             // {
                        //             //     displayType: "date",
                        //             //     key: "Listed At",
                        //             //     value: item?.date?.toISOString()
                        //             // },
                        //             // {
                        //             //     displayType: "link",
                        //             //     key: "From",
                        //             //     value: item?.from?.value,
                        //             //     link: item?.from?.link
                        //             // },
                        //             // {
                        //             //     displayType: "link",
                        //             //     key: "To",
                        //             //     value: item?.to?.value,
                        //             //     link: item?.to?.link
                        //             // },
                        //             // {
                        //             //     displayType: "link",
                        //             //     key: "Proof of List",
                        //             //     value: item?.proof?.value,
                        //             //     link: item?.proof?.link
                        //             // }
                        //         ]
                        //     })
                        // }),
                    }
                if(_found){
                    return _found;
                }
                
                }
                // log.success(SERVICE_NAME, "get asset detail result: ", res);
                // // return res?.data?.getAssets;
                // return res?.data?.getAsset;
            }
        } catch (err) {
            return err;
        }
    }


    async listAssetService(data: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `data in service`, data);
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: LIST_ASSET,
                    variables: {
                        input: data
                    },
                    fetchPolicy:"no-cache"
                });
                log.success(MODULE_NAME, "LIIST ASSET: ", res);
                if(res?.data?.listAssetToStore){
                    return res?.data;
                }
            }
           
        } catch (err) {}
    }

    _getFormData(data: any) {
        console.log("itsme",data)
        let _initialOptions =
            data &&
            Array.isArray(data) &&
            data.map((item, index) => {
                return {
                    label: item && humanize(item),
                    value: item,
                };
            });
            console.log("itsu",_initialOptions)
        let result = LIST_ASSET_FORM_DATA.map((item, index) => {
            if (item?.name === "selectCategory") {
                return {
                    ...item,
                    fieldProps: {
                        ...item?.fieldProps,
                        initialOptions: _initialOptions,
                    },
                };
            } else {
                return {
                    ...item,
                };
            }
        });
        return result;
    }



   
    async getCategories() {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: GET_CATEGORIES,
                    variables: {
                        storeId: "61739cbd2fbe0a187c984fb6"
                    },
                    fetchPolicy: "network-only",
                });
                if (res?.data) {
                   console.log("itsdata",res?.data)
                    return {
                        LIST_ASSET_FORM_DATA: this._getFormData(res?.data?.getCategoriesByStore?.categories),
                        LIST_ASSET_FIELDS,
                    };
                }
            }
        } catch (err) {}
    }
  
    // async listAssetService(data: any) {
    //     log.blue(MODULE_NAME ,": list data : ", data)
    //     const graphqlModule = getGraphQLModule();
    //     const client = graphqlModule.getClient("graphql-gateway");
    //     try {
    //         if (client) {
    //             const res = await client.mutate({
    //                 mutate: LIST_ASSET,
    //                 variables: {
    //                     input: {...data}
                        
    //                 },
    //                 fetchPolicy:'no-cache'
    //             });
    //             log.success(MODULE_NAME, "LIIST ASSET: ", res);
    //             return res?.data;
    //         }
    //         return true
    //     } catch (err) {

    //     }
    // }
}
